module.exports = __webpack_public_path__ + "img/21e96c7.jpg";